import { normalizeWidgetTheme, APIURL, cancelSelectEvent, getCSSStyles, getWidgetDataURI, apiGet, toggleWidgetTheme, isHeaderPinned, getHeaderPinStateClass, getHeaderPinButtonHTML, setupHeaderPin, getNoDataHTML, isEmptyWidgetData } from '../../helpers';
import { WidgetConfig, WidgetEvent, WidgetEventHandler, WidgetEventType } from '../../types';

export class TraderverseCryptoCompanyMarket {
  private container: HTMLElement;
  private config: WidgetConfig;
  private eventHandlers: Map<WidgetEventType, WidgetEventHandler[]> = new Map();
  private updateInterval: number | null = null;
  private shadowRoot: ShadowRoot;
  private currentData: any = null;
  private widgetResizeObserver: ResizeObserver | null = null;

  constructor(config: WidgetConfig) {
    this.config = { ...this.getDefaultConfig(), ...config };
    this.config.theme = normalizeWidgetTheme(this.config.theme);
    this.container = this.resolveContainer(config.container);

    if ((this.container as any).shadowRoot) {
      this.shadowRoot = (this.container as any).shadowRoot;
    } else {
      this.shadowRoot = this.container.attachShadow({ mode: 'closed' });
    }
    this.init();

    this.widgetResizeObserver = new ResizeObserver(() => {
      this.updateDisplay();
    });
    setTimeout(() => {
      const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
      if (widget) this.widgetResizeObserver?.observe(widget);
    }, 0);
  }


  private fetchSymbols(): Array<{ value: string; label: string }> {
    return [
      { label: 'AAPL', value: 'AAPL' }, { label: 'MSFT', value: 'MSFT' },
      { label: 'GOOGL', value: 'GOOGL' }, { label: 'AMZN', value: 'AMZN' },
      { label: 'NVDA', value: 'NVDA' }, { label: 'META', value: 'META' },
      { label: 'TSLA', value: 'TSLA' }, { label: 'AVGO', value: 'AVGO' },
      { label: 'PEP', value: 'PEP' }, { label: 'COST', value: 'COST' }
    ];
  }

  private getDefaultConfig(): Partial<WidgetConfig> {
    const symbols = this.fetchSymbols();
    return {
      headerPinned: true,
      symbol: symbols[0].value,
      theme: 'default-dark',
      width: '100%',
      height: '400px',
      autosize: true
    };
  }

  private resolveContainer(container: string | HTMLElement): HTMLElement {
    if (typeof container === 'string') {
      const el = document.getElementById(container) || document.querySelector(container);
      if (!el) throw new Error(`Container not found: ${container}`);
      return el as HTMLElement;
    }
    return container;
  }

  private async init(): Promise<void> {
    if (!this.config.symbol) this.config.symbol = this.fetchSymbols()[0].value;

    this.createWidget();
    const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
    if (widget) widget.classList.add('loading');
    this.attachStyles();
    await this.setupChart();
    if (widget) widget.classList.remove('loading');
    this.emit('ready', {});
    this.config.onReady?.();
    cancelSelectEvent(this.shadowRoot);
  }

  private createWidget(): void {
    let themeClass = 'defaultDarkMode';
  let dataTheme = 'default-dark';
  
  if (this.config.theme === 'white') {
    themeClass = 'whiteMode';
    dataTheme = 'white';
  } else if (this.config.theme === 'black') {
    themeClass = 'blackMode';
    dataTheme = 'black';
  } else if (this.config.theme === 'default-lite') {
  themeClass = 'defaultLightMode';
  dataTheme = 'default-lite';
}
    const widgetHtml = `
      <div style="width: ${typeof this.config.width == "number" ? this.config.width+ 'px' : this.config.width  };height: ${typeof this.config.height == "number" ? this.config.height+ 'px' : this.config.height};" class="widgetBox ${themeClass} loading ${getHeaderPinStateClass(this.config)}" data-theme="${dataTheme}">
        <div class="headTop">
          <h4 class="title crypto">${this.getTitleIconSvg()} Company Market</h4>
          <div class="actionCol">${getHeaderPinButtonHTML(this.config)}<div class="item">
                <button class="filters-toggle" type="button"> <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.1794 0.950592H1.72077C1.57285 0.950469 1.42802 0.991908 1.30363 1.06995C1.17925 1.14799 1.08058 1.25932 1.01944 1.39061C0.958302 1.5219 0.937286 1.66759 0.958909 1.81023C0.980533 1.95286 1.04388 2.0864 1.14136 2.19484L5.22108 6.73834C5.34378 6.8752 5.41132 7.05084 5.41114 7.23259V10.8881C5.41114 10.9463 5.42504 11.0037 5.45175 11.0558C5.47846 11.1079 5.51725 11.1532 5.56503 11.1881L7.87343 12.8756C7.93059 12.9174 7.99856 12.9428 8.06972 12.9491C8.14088 12.9553 8.21242 12.9421 8.27633 12.911C8.34023 12.8799 8.39398 12.832 8.43154 12.7727C8.46911 12.7135 8.489 12.6452 8.489 12.5756V7.23259C8.48882 7.05084 8.55636 6.8752 8.67906 6.73834L12.7588 2.19409C13.1943 1.70959 12.8403 0.950592 12.1794 0.950592Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/> </svg> </button>
              </div></div>
        </div>

        <div class="inBody">
          <div class="optionsRow">
            <div class="item"></div>
            <span></span>

            <div class="filtersBox sideBar hidden">
              <div class="item">
                <label>Type</label>
                <div class="tokenBtns type-tabs">
                  <button class="tab" data-type="loser">Loser</button>
                  <button class="tab" data-type="winner">Gainer</button>
                </div>
              </div>
              <div class="item">
                <label>Source</label>
                <div class="tokenBtns source-tabs">
                  <button class="tab" data-source="coinmarketcap">CoinMarketCap</button>
                  <button class="tab" data-source="coingecko">CoinGecko</button>
                </div>
              </div>
              <div class="item">
                <label>Coin Range</label>
                <select class="topCoins-select">
                  <option value="all">All Coins</option>
                  <option value="top_100">Top 100</option>
                  <option value="top_300">Top 300</option>
                  <option value="top_1000">Top 1000</option>
                </select>
              </div>
              <div class="item">
                <label>Period</label>
                <select class="period-select">
                  <option value="1h">1 Hour</option>
                  <option value="24h">24 Hours</option>
                  <option value="7d">7 Days</option>
                  <option value="14d">14 Days</option>
                  <option value="30d">30 Days</option>
                  <option value="60d">60 Days</option>
                  <option value="1y">1 Year</option>
                </select>
              </div>
            </div>
          </div>
          <div class="chartDv" id="eventsContainer" style="height: 100%; padding: 0; margin: 0;"></div>
        </div>
      </div>
    `;

    this.shadowRoot.innerHTML = widgetHtml;
    setupHeaderPin(this.shadowRoot, this.config);

    const filtersToggleBtn = this.shadowRoot.querySelector('.filters-toggle') as HTMLButtonElement | null;
    const filtersBox = this.shadowRoot.querySelector('.filtersBox') as HTMLElement | null;
    if (filtersToggleBtn && filtersBox) {
      filtersToggleBtn.addEventListener('click', () => {
        filtersBox.classList.toggle('hidden');
      });
    }

    const typeTabs = this.shadowRoot.querySelectorAll('.type-tabs .tab');
    const sourceTabs = this.shadowRoot.querySelectorAll('.source-tabs .tab');

    typeTabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        const target = e.target as HTMLElement;
        const type = target.dataset.type as 'winner' | 'loser';

        typeTabs.forEach(t => t.classList.remove('active'));
        target.classList.add('active');

        this.setupChart(type, undefined);
      });
    });

    sourceTabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        const target = e.target as HTMLElement;
        const source = target.dataset.source as 'coinmarketcap' | 'coingecko';

        sourceTabs.forEach(t => t.classList.remove('active'));
        target.classList.add('active');

        this.setupChart(undefined, source);
      });
    });

    const topCoinsSelect = this.shadowRoot.querySelector('.topCoins-select') as HTMLSelectElement;
    if (topCoinsSelect) {
      topCoinsSelect.addEventListener('change', (e) => {
        const target = e.target as HTMLSelectElement;
        const topCoins = target.value as 'all' | 'top_100' | 'top_300' | 'top_1000';
        this.setupChart(undefined, undefined, topCoins, undefined);
      });
    }

    const periodSelect = this.shadowRoot.querySelector('.period-select') as HTMLSelectElement;
    if (periodSelect) {
      periodSelect.addEventListener('change', (e) => {
        const target = e.target as HTMLSelectElement;
        const period = target.value as '1h' | '24h' | '7d' | '14d' | '30d' | '60d' | '1y';
        this.setupChart(undefined, undefined, undefined, period);
      });
    }

    this.syncFilterUI();
  }

  private async attachStyles(): Promise<void> {
    try {
      const styleEl = await getCSSStyles();
      this.shadowRoot.appendChild(styleEl);
    } catch (err) {
      console.error('Failed to load CSS file:', err);
    }
  }

  private currentType: 'winner' | 'loser' = 'loser';
  private currentSource: 'coinmarketcap' | 'coingecko' = 'coinmarketcap';
  private currentTopCoins: 'all' | 'top_100' | 'top_300' | 'top_1000' = 'all';
  private currentPeriod: '1h' | '24h' | '7d' | '14d' | '30d' | '60d' | '1y' = '1h';

  private syncFilterUI(): void {
    const typeTabs = Array.from(this.shadowRoot.querySelectorAll('.type-tabs .tab')) as HTMLElement[];
    const sourceTabs = Array.from(this.shadowRoot.querySelectorAll('.source-tabs .tab')) as HTMLElement[];
    const topCoinsSelect = this.shadowRoot.querySelector('.topCoins-select') as HTMLSelectElement | null;
    const periodSelect = this.shadowRoot.querySelector('.period-select') as HTMLSelectElement | null;

    typeTabs.forEach((tab) => {
      tab.classList.toggle('active', tab.getAttribute('data-type') === this.currentType);
    });

    sourceTabs.forEach((tab) => {
      tab.classList.toggle('active', tab.getAttribute('data-source') === this.currentSource);
    });

    if (topCoinsSelect) topCoinsSelect.value = this.currentTopCoins;
    if (periodSelect) periodSelect.value = this.currentPeriod;
  }

  private async setupChart(
    type?: 'winner' | 'loser',
    source?: 'coinmarketcap' | 'coingecko',
    topCoins?: 'all' | 'top_100' | 'top_300' | 'top_1000',
    period?: '1h' | '24h' | '7d' | '14d' | '30d' | '60d' | '1y'
  ): Promise<void> {
    try {
      if (type) this.currentType = type;
      if (source) this.currentSource = source;
      if (topCoins) this.currentTopCoins = topCoins;
      if (period) this.currentPeriod = period;
      this.syncFilterUI();

      const response = await apiGet({
        method: 'GET',
        url: `${APIURL}/v1/crypto/crypto_market_winner_loser?limit=10&offset=0&type=${this.currentType}&source=${this.currentSource}&topCoins=${this.currentTopCoins}&period=${this.currentPeriod}`,
        body: { limit: 10, offset: 0, type: this.currentType, source: this.currentSource, topCoins: this.currentTopCoins, period: this.currentPeriod },
        headers: { 'Content-Type': 'application/json' }
      });

      if (!response.ok) throw new Error("Failed to fetch data");
      this.currentData = await response.json();
      this.updateDisplay();
      this.emit('dataUpdate', this.currentData);
    } catch (err) {
      console.error("Error fetching chart data:", err);
    }
  }

  private trendingCoins(): void {
    if (!this.currentData?.data) return;
    let filtered = this.currentData.data;

    this.renderTrendingCoins(filtered);
  }

  private renderTrendingCoins(eventsData: any): void {
    const container = this.shadowRoot.querySelector('#eventsContainer');
    if (!container) return;

    if (!eventsData?.docs || eventsData.docs.length === 0) {
      container.innerHTML = getNoDataHTML();
      return;
    }

    const formatMarketCap = (num: number): string => {
      if (num >= 1_000_000_000_000) return (num / 1_000_000_000_000).toFixed(2) + 'T';
      if (num >= 1_000_000_000) return (num / 1_000_000_000).toFixed(2) + 'B';
      if (num >= 1_000_000) return (num / 1_000_000).toFixed(2) + 'M';
      if (num >= 1_000) return (num / 1_000).toFixed(2) + 'K';
      return num.toString();
    };

    const formatPercent = (value: number | null | undefined): string => {
      if (value === null || value === undefined || isNaN(value)) return '-';
      const color = value >= 0 ? 'green' : 'red';
      return `<span class="${color}">${value.toFixed(2)}%</span>`;
    };

    let html = `
    <div class="eventsMain cryptoTopMoversMain">
      <div class="item header">
        <p>Coin</p>
        <p>Price</p>
        <p>Market Cap</p>
        <p>1H%</p>
        <p>24H%</p>
        <p>7D%</p>
        <p>24H VOL</p>
        <p>24H VOL %</p>
        <p>Circ. Supply</p>
        <p>Rank</p>
      </div>
  `;

    for (const item of eventsData.docs) {
      const logoUrl = `https://media.traderverse.io/assets/crypto/${item.symbol.toUpperCase().replace('USD', '')}_CRYPTO.svg`;
      const fallbackUrl = `https://cdn-images.traderverse.io/crypto_dummy.svg`;
      const price = item.quote?.USD?.price ? `$${item.quote.USD.price.toLocaleString()}` : '-';
      const marketCap = item.quote?.USD?.market_cap ? `$${formatMarketCap(item.quote.USD.market_cap)}` : '-';
      const volume = item.quote?.USD?.volume_24h ? `$${formatMarketCap(item.quote.USD.volume_24h)}` : '-';
      const circSupply = item.circulating_supply ? formatMarketCap(item.circulating_supply) : '-';

      html += `
      <div class="item body">
        <p>  <img 
            src="${logoUrl}" 
            width="20" 
            height="14" 
            style="vertical-align:middle;" 
            onerror="this.onerror=null;this.src='${fallbackUrl}';"
          />  ${item.symbol} - ${item.name}</p>
        <p>${price}</p>
        <p>${marketCap}</p>
        <p class="rangeFigure">${formatPercent(item.quote?.USD?.percent_change_1h)}</p>
        <p class="rangeFigure">${formatPercent(item.quote?.USD?.percent_change_24h)}</p>
        <p class="rangeFigure">${formatPercent(item.quote?.USD?.percent_change_7d)}</p>
        <p>${volume}</p>
        <p class="rangeFigure">${formatPercent(item.quote?.USD?.volume_change_24h)}</p>
        <p>${circSupply}</p>
        <p class="stat">${item.cmc_rank ?? '-'}</p>
      </div>
    `;
    }

    html += `</div>`;
    container.innerHTML = html;
  }

  private updateDisplay(): void {
    const container = this.shadowRoot.querySelector('#eventsContainer') as HTMLElement;
    if (!this.currentData) {
      setTimeout(() => this.updateDisplay(), 100);
      return;
    }
    if (isEmptyWidgetData(this.currentData.data?.docs)) {
      if (container) container.innerHTML = getNoDataHTML();
      return;
    }
    this.trendingCoins();
  }

  public on(type: WidgetEventType, handler: WidgetEventHandler): void {
    if (!this.eventHandlers.has(type)) this.eventHandlers.set(type, []);
    this.eventHandlers.get(type)!.push(handler);
  }

  public off(type: WidgetEventType, handler: WidgetEventHandler): void {
    const list = this.eventHandlers.get(type);
    if (list) this.eventHandlers.set(type, list.filter(h => h !== handler));
  }

  public setSymbol(symbol: string): void {
    this.config.symbol = symbol;
    this.setupChart();
  }

  public async getWidgetImage(): Promise<string> {
    const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
    return await getWidgetDataURI(widget);
  }
  
  public setTheme(theme: 'white' | 'black' | 'default-dark' | 'default-lite' | 'default-lite'): void {
    if (!this.shadowRoot) return;
  
    this.config.theme = toggleWidgetTheme(
      this.shadowRoot,
      theme
    ) as 'white' | 'black' | 'default-dark' | 'default-lite' | 'default-lite';
  
    this.updateDisplay();
  }

  public destroy(): void {
    if (this.updateInterval) { clearInterval(this.updateInterval); this.updateInterval = null; }
    if (this.widgetResizeObserver) { this.widgetResizeObserver.disconnect(); this.widgetResizeObserver = null; }
    this.eventHandlers.clear(); this.shadowRoot.innerHTML = '';
  }

  private emit(type: WidgetEventType, data: any): void {
    const handlers = this.eventHandlers.get(type);
    if (handlers) { const evt: WidgetEvent = { type, data }; handlers.forEach(h => h(evt)); }
  }
  private getTitleIconSvg(): string {
    return `<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M15.15 20.3C12.3125 20.3 10 17.9875 10 15.15C10 12.3125 12.3125 10 15.15 10C17.9875 10 20.3 12.3125 20.3 15.15C20.3 17.9875 18 20.3 15.15 20.3ZM15.15 11.8625C13.3375 11.8625 11.875 13.3375 11.875 15.1375C11.875 16.9375 13.35 18.4125 15.15 18.4125C16.95 18.4125 18.425 16.9375 18.425 15.1375C18.425 13.3375 16.9625 11.8625 15.15 11.8625Z" fill="currentColor"/> <path d="M15 28.4375C7.5875 28.4375 1.5625 22.4125 1.5625 15C1.5625 7.5875 7.5875 1.5625 15 1.5625C22.4125 1.5625 28.4375 7.5875 28.4375 15C28.4375 22.4125 22.4125 28.4375 15 28.4375ZM15 3.4375C8.625 3.4375 3.4375 8.625 3.4375 15C3.4375 21.375 8.625 26.5625 15 26.5625C21.375 26.5625 26.5625 21.375 26.5625 15C26.5625 8.625 21.375 3.4375 15 3.4375Z" fill="currentColor"/> <path d="M15.0625 22C14.5158 22 14.0625 21.5192 14.0625 20.9394V9.06061C14.0625 8.48081 14.5158 8 15.0625 8C15.6092 8 16.0625 8.48081 16.0625 9.06061V20.9394C16.0625 21.5192 15.6092 22 15.0625 22Z" fill="currentColor"/> </svg>`;
  }

}

declare global { interface Window { TraderverseCryptoCompanyMarket: typeof TraderverseCryptoCompanyMarket; } }
if (typeof window !== 'undefined') { window.TraderverseCryptoCompanyMarket = TraderverseCryptoCompanyMarket; }
